import React, { Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';

// Components
import Home from './views/Home';
import Login from './views/Login';
import Dashboard from './views/Dashboard';
import Support from './views/Support';
import Challenges from './views/Challenges';
import ReportsList from './views/Reports/ReportsList';
import ReportView from './views/Reports/ReportView';
import Users from './views/Users';
import AuthGuard from './components/Auth/AuthGuard';
import AuthGuardAdmin from './components/Auth/AuthGuardAdmin';
import AuthGuardRedirect from './components/Auth/AuthGuardRedirect';
import Layout from './components/Layout';
import WalletList from './views/Wallet/WalletList';
import WalletDetail from './views/Wallet/WalletDetail';
import ResetPassword from './views/ForgottenPassword/resetPassword';
import RecoverPassword from './views/ForgottenPassword/recoverPassword';
import Terms from './views/Terms';
import Gantt from './views/Gantt';
import Register from './views/Register';
import UserVerification from './views/UserVerification';
import Documents from './views/Documents';
import Locations from './views/Locations';
import Products from './views/Products';
import ProductsImportView from './views/ProductsImportView';
import ProductsImages from './views/ProductsImages';
import LocationsImportView from './views/LocationsImportView';
import Groups from './views/Groups';
import Categories from './views/Categories';
import UserDetail from './views/Users/userDetailView';
// import Tasks from './views/Tasks';
import Administration from './views/Administration';
import Teleaudit from './views/Teleaudit/ImageTeleaudit';
import QA from './views/QA';
import Responses from './views/Responses';
import QuestionResponses from './views/Responses/questionResponses';
// import SurveyResponsesView from './views/QA/surveyResponsesView';
import QuestionResponsesView from './views/QA/questionResponsesView';
import PreTeleaudit from './views/Teleaudit';
import UserReportView from './views/Users/userReportView';
import ProductLocations from './views/ProductLocationsImportView';
import StockAndSales from './views/StockAndSalesImportView';
import UserProjectsImportView from './views/UserProjectsImportView';
import LocationProjectsImportView from './views/LocationProjectsImportView';
import LocationUsersImportView from './views/LocationUsersImportView';
import QuestionResponsesTeleauditView from './views/Teleaudit/questionResponsesView';
import EditQuestionResponse from './views/Responses/EditQuestionResponse';
import EditResponse from './views/Responses/EditResponse';
import TaskDetail from './views/Surveys/PageView/TaskDetail';
import TaskList from './views/Surveys/PageView/TaskList';
import TaskEdit from './views/Surveys/PageView/TaskEdit';
import TaskAssociation from './views/Surveys/PageView/TaskAssociation';
import CreateTask from './views/Surveys/PageView/CreateTask';
import DuplicateTask from './views/Surveys/PageView/DuplicateTask';
import TaskEditDetail from './views/Surveys/PageView/TaskEditDetail';
import EmailConfig from './views/Surveys/EmailConfig';
import ProductGroupsDetailView from './views/ProductGroupsViews/ProductGroupsDetailView';
import ProductGroupsBulkUploadView from './views/ProductGroupsViews/ProductGroupsBulkUploadView';
import ProductGroupsListView from './views/ProductGroupsViews/ProductGroupsListView';
import TaskInstanceEdit from './views/TaskInstance/TaskInstanceEdit';
import PriceTeleaudit from './views/Teleaudit/PriceTeleaudit';
import PublicVideoView from './views/PublicVideoView';
import News from './views/News';
import BulkAssociation from './views/BulkAssociation';
import AuthGuardSuperAdmin from './components/Auth/AuthGuardSuperAdmin';

const routesConfig = [
  {
    id: 1,
    exact: true,
    path: '/',
    component: () => <Home />,
  },
  {
    id: 2,
    exact: true,
    path: '/login',
    component: () => <Login />,
  },
  {
    id: 3,
    exact: true,
    path: '/recover-password',
    component: () => <RecoverPassword />,
  },
  {
    id: 4,
    exact: true,
    path: '/reset-password',
    component: () => <ResetPassword />,
  },
  {
    id: 5,
    exact: true,
    path: '/user-verification',
    component: () => <UserVerification />,
  },
  {
    id: 6,
    exact: true,
    path: '/public-videos/:taskResponseId/:questionResponseId',
    component: () => <PublicVideoView />,
  },
  {
    id: 100,
    path: '/',
    guard: AuthGuard,
    layout: Layout,
    routes: [
      {
        id: 101,
        exact: true,
        guard: [AuthGuardAdmin, AuthGuardRedirect],
        path: '/home',
        component: () => <Dashboard />,
      },
      {
        id: 102,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/support',
        component: () => <Support />,
      },
      {
        id: 103,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/users',
        component: () => <Users />,
      },
      {
        id: 104,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/reports',
        component: () => <ReportsList />,
      },
      {
        id: 105,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/reports/:id',
        component: () => <ReportView />,
      },
      {
        id: 106,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/wallet',
        component: () => <WalletList />,
      },
      {
        id: 107,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tyc',
        component: () => <Terms />,
      },
      {
        id: 108,
        exact: true,
        path: '/wallet/:id',
        component: () => <WalletDetail />,
      },
      {
        id: 109,
        exact: true,
        path: '/register',
        component: () => <Register />,
      },
      {
        id: 110,
        exact: true,
        path: '/gantts',
        component: () => <Gantt />,
      },
      {
        id: 111,
        exact: true,
        path: '/documents',
        component: () => <Documents />,
      },
      {
        id: 112,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/locations',
        component: () => <Locations />,
      },
      {
        id: 113,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/products',
        component: () => <Products />,
      },
      {
        id: 114,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/upload-products',
        component: () => <ProductsImportView />,
      },
      {
        id: 115,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/upload-locations',
        component: () => <LocationsImportView />,
      },
      // {
      //   id: 116,
      //   exact: true,
      //   guard: AuthGuardAdmin,
      //   path: '/surveys',
      //   component: () => <Surveys />,
      // },
      {
        id: 117,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/groups',
        component: () => <Groups />,
      },
      {
        id: 118,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/categories',
        component: () => <Categories />,
      },
      {
        id: 119,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/users/:id',
        component: () => <UserDetail />,
      },
      {
        id: 120,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks',
        component: () => <TaskList />,
      },
      {
        id: 121,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/administration',
        component: () => <Administration />,
      },
      {
        id: 122,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/qa',
        component: () => <QA />,
      },
      {
        id: 123,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/qa/:taskResponseId',
        //   component: () => <SurveyResponsesView />,
        // },
        // {
        //   id: 124,
        //   exact: true,
        //   guard: AuthGuardAdmin,
        //   path: '/qa/:id/:surveyResponseId',
        component: () => <QuestionResponsesView />,
      },
      {
        id: 125,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/challenges',
        component: () => <Challenges />,
      },
      {
        id: 126,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/users/:userId/report/:reportId',
        component: () => <UserReportView />,
      },
      {
        id: 127,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/teleaudit',
        component: () => <PreTeleaudit />,
      },
      {
        id: 128,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/teleaudits/:taskResponseId/:type',
        component: () => <QuestionResponsesTeleauditView />,
      },
      {
        id: 156,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/teleaudit/:taskResponseId/:questionResponseId/price',
        component: () => <PriceTeleaudit />,
      },
      {
        id: 129,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/teleaudit/:taskResponseId/:questionResponseId/:type',
        component: () => <Teleaudit />,
      },
      {
        id: 130,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/upload-product-locations',
        component: () => <ProductLocations />,
      },
      {
        id: 131,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/upload-stock-and-sales-information',
        component: () => <StockAndSales />,
      },
      {
        id: 132,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/user-projects',
        component: () => <UserProjectsImportView />,
      },
      {
        id: 133,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/location-projects',
        component: () => <LocationProjectsImportView />,
      },
      {
        id: 157,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/location-users',
        component: () => <LocationUsersImportView />,
      },
      {
        id: 134,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/responses',
        component: () => <Responses />,
      },
      {
        id: 135,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/responses/:taskResponseId',
        component: () => <QuestionResponses />,
      },
      {
        id: 137,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/upload-products-images',
        component: () => <ProductsImages />,
      },
      {
        id: 138,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/responses/:taskResponseId/:questionResponseId/edit',
        component: () => <EditQuestionResponse />,
      },
      {
        id: 139,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/responses/:taskResponseId/edit',
        component: () => <EditResponse />,
      },
      {
        id: 140,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/create',
        component: () => <CreateTask />,
      },
      {
        id: 141,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/:taskId',
        component: () => <TaskDetail />,
      },
      {
        id: 142,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/:taskId/edit',
        component: () => <TaskEdit />,
      },
      {
        id: 143,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/:taskId/associations',
        component: () => <TaskAssociation edit={false} />,
      },
      {
        id: 144,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/:taskId/associations/edit',
        component: () => <TaskAssociation edit={true} />,
      },
      {
        id: 145,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/create',
        component: () => <CreateTask />,
      },
      {
        id: 146,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/:taskId/duplicate',
        component: () => <DuplicateTask />,
      },
      {
        id: 147,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/:taskId/edit-detail',
        component: () => <TaskEditDetail />,
      },
      {
        id: 148,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/surveys/email-config/:surveyId',
        component: () => <EmailConfig />,
      },
      {
        id: 149,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/product-groups',
        component: () => <ProductGroupsListView />,
      },
      {
        id: 150,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/product-groups/bulk-upload',
        component: () => <ProductGroupsBulkUploadView />,
      },
      {
        id: 151,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/product-groups/create',
        component: () => <ProductGroupsDetailView></ProductGroupsDetailView>,
      },
      {
        id: 152,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/product-groups/:productGroupId/:mode?',
        component: () => <ProductGroupsDetailView></ProductGroupsDetailView>,
      },
      {
        id: 153,
        exact: true,
        guard: AuthGuardAdmin,
        path: '/tasks/:taskId/associations/:taskInstanceId/edit',
        component: () => <TaskInstanceEdit></TaskInstanceEdit>,
      },
      {
        id: 154,
        exact: true,
        path: '/news/:slug',
        component: () => <News />,
      },
      {
        id: 155,
        exact: true,
        guard: AuthGuardSuperAdmin,
        path: '/bulk-association',
        component: () => <BulkAssociation />,
      },
    ],
  },
];

const renderRoutes = (routes) => (routes ? (
  <Switch>
    {routes.map((route) => {
      const guards = Array.isArray(route.guard) ? route.guard : [route.guard || Fragment];
      const DefaultLayout = route.layout || Fragment;
      const Component = route.component;

      const renderWithGuards = (content, guardIndex = 0) => {
        if (guardIndex >= guards.length) return content;
        const Guard = guards[guardIndex];
        return <Guard>{renderWithGuards(content, guardIndex + 1)}</Guard>;
      };

      return (
        <Route
          key={route.id}
          path={route.path}
          exact={route.exact}
          render={() => renderWithGuards(
            <DefaultLayout>
              {route.routes ? renderRoutes(route.routes) : <Component />}
            </DefaultLayout>,
          )}
        />
      );
    })}
  </Switch>
) : null);

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
